import React, { useEffect, useState } from 'react';
import Layout from 'layout/layout';
import OffCanvasModal from 'components/offCanvas-modal';
import { GoCheckCircle, GoChevronRight, GoFilter, GoPlus, GoStar, GoTriangleDown } from 'react-icons/go';
import { FloatingLabel, Form, Spinner, Table } from 'react-bootstrap';
import { FiFolderMinus, FiFolderPlus, FiArrowUpRight } from 'react-icons/fi';
import { PiFolderOpen } from 'react-icons/pi';
import { HiOutlineChartBar } from 'react-icons/hi2';
import info from '../../assets/images/info.gif';
import assignBulk from '../../assets/images/assign-bulk.gif';
import ModalComponent from 'components/modal-component';
import { useAddCategoryMutation, useAssignBulkTicketMutation, useGetAllCategoriesQuery, useGetAllTicketQuery, useUpdateTicketStatusMutation } from 'api/requestApi';
import { Priority, TicketCategoryModel, TicketDto, TicketDtoPaginationResult, TicketQuery, TicketStatus, UpdateTicketStatus } from 'model/request-model';
import TicketDetails from './TicketDetails';
import NewTicket from './NewTicket';
import dayjs from 'dayjs';
import { showToastError, showToastSuccess } from 'components/toastify/ToastNotifications';
import ReportStatistics from './reportStatistics';
import RequestSubscription from './Subscriptions';
import LiveChatHistory from './livechat-history';
import { useGetPermissionsByIdQuery, useGetUsersQuery } from 'api/userManagementApi';
import { ItemModel } from 'model/users-model';
import { useFormik } from 'formik';
import { builkAssignTicket } from 'validation-schema/ticket-schema';
import Pagination from 'rc-pagination';
import 'rc-pagination/assets/index.css'; // Import Pagination CSS
import { retrieveUserData } from 'redux/authSlice';
import { BiUpArrowAlt } from 'react-icons/bi';
import { IoChatboxEllipses } from "react-icons/io5";
import { FaArrowDown, FaArrowUp, FaSearch } from 'react-icons/fa';
import { usePermissions } from 'hooks/user-permissions';
import "../../styles/request.css";
type Props = {}

type filterProps = {
  status: string;
  categoryName: string;
  sortBy: string;
  searchKeyword: string;
  priority: string;
}

const Request: React.FC = (props: Props) => {

  const { hasPermissions, isFetching } = usePermissions(["View Requests", "Manage Requests"]);

  const [loading, setLoading] = useState(false);
  const [loadingBulkAssign, setLoadingBulkAssign] = useState(false);
  const [loadingStatus, setLoadingStatus] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showOffCanvas, setShowOffCanvas] = useState(false);
  const [activeTab, setActiveTab] = useState('All');
  const [activeFilter, setActiveFilter] = useState('All');
  const [checkedAll, setCheckedAll] = useState(false);
  const [checkedTickets, setCheckedTickets] = useState<TicketDto[]>([]);
  const [allcategories, setAllCategories] = useState<TicketCategoryModel[]>([]);
  const [ticketDetails, setTicketDetails] = useState<TicketDto>();
  const [tickets, setTickets] = useState<TicketDtoPaginationResult | null>();
  const [ticketsFilter, setTicketsFilter] = useState<TicketDto[] | null>();
  const [adminUsers, setAdminUsers] = useState<ItemModel>();

  const [modalTab, setModalTab] = useState('');
  const [sideDrawerFilter, setSideDrawerFilter] = useState<filterProps>({
    status: '',
    categoryName: '',
    sortBy: '',
    searchKeyword: '',
    priority: ''
  });
  const [query, setQuery] = useState<TicketQuery>({
    PageSize: 10,
    Page: 1,
  });


  const { data: categories, error: categoriesError, isFetching: catIsFetching, refetch: catRefetch } = useGetAllCategoriesQuery();

  useEffect(() => {
    if (catIsFetching) {
      setLoading(true);
    }
    else {
      setLoading(false);
      if (categoriesError) {
        showToastError("Unable to fetch data from the server");
      }
      else {
        setAllCategories(categories?.data as TicketCategoryModel[])
      }
    }
  }, [catIsFetching]);

  const { data: usersData, error: usersError, isFetching: usersIsFetching, refetch: refetchUser } = useGetUsersQuery();
  useEffect(() => {
    if (usersIsFetching) {
      setLoading(true);
    }
    else {
      setLoading(false);
      if (usersError) {
        showToastError("Unable to fetch data from the server");
      } else {
        setAdminUsers(usersData?.data as ItemModel)
      }
    }
  }, [usersIsFetching]);

  //Use the useGetAllTicketQuery hook with the query object
  const { data: getAllTickets, error: getAllTicketsError, isFetching: getAllTicketisFetching, refetch: getAllTicketRefresh } = useGetAllTicketQuery(query, {
    //pollingInterval: 3000,
    //skipPollingIfUnfocused: true,
  });

  useEffect(() => {
    if (getAllTicketisFetching) {
      setLoading(true);
    }
    else {
      setLoading(false);
      if (getAllTicketsError) {
        showToastError("Unable to fetch data from the server");
      } else {
        setTickets(getAllTickets?.data as TicketDtoPaginationResult);
        setTicketsFilter(getAllTickets?.data?.items as TicketDto[]);
      }
    }
  }, [getAllTicketisFetching, query]);

  const [updateTicketStatus] = useUpdateTicketStatusMutation();

  const handleUpdateTicketStatus = async () => {
    try {
      setLoadingStatus(true);
      const model: UpdateTicketStatus = {
        ticketId: ticketDetails?.id || '',
        status: TicketStatus?.RESOLVED
      }
      const response = await updateTicketStatus(model).unwrap();
      if (response) {
        showToastSuccess(response?.ResponseMessage);
        handleHideModal();
      }
    }
    catch (error: any) {
      showToastError(error?.data.ResponseMessage)
    }
    finally {
      setLoadingStatus(false);
    }
  }

  const handleHideModal = () => {
    setShowModal(false);
  };

  const handleHideOffCanvas = () => {
    setShowOffCanvas(false);
  }

  const handleReturn = () => {
    getAllTicketRefresh();
    setActiveFilter('New');
    setTicketDetails(undefined);
  }

  const [addCategory] = useAddCategoryMutation();
  const [loadingCategory, setLoadingCategory] = useState(false);
  const [newCategory, setNewCategory] = useState<string>('');
  const handleAddCategory = async () => {
    try {
      setLoadingCategory(true);
      const model = {
        "categoryName": newCategory
      }
      const response = await addCategory(model).unwrap();
      if (response) {
        showToastSuccess(response?.ResponseMessage);
        handleHideModal();
      }
    }
    catch (error: any) {
      showToastError(error?.data.ResponseMessage)
    }
    finally {
      setLoadingCategory(false);
    }
  }

  const handleFilterTicket = (catId: string) => {
    if (catId === 'all') {
      setTicketsFilter(tickets?.items);
    }
    else {
      setTicketsFilter(tickets?.items?.filter(item => item?.categoryId === catId))
    }
  }

  const handleStatusTicket = (status: string) => {
    if (status.toLowerCase() === 'all') {
      setTicketsFilter(tickets?.items);
      setActiveFilter(status);
    }
    else {
      setTicketsFilter(tickets?.items?.filter(item => item?.status === status));
      setActiveFilter(status);
    }
  }

  const handleSearchKeyword = (searchKeyword: string) => {
    setTicketsFilter(
      tickets?.items?.filter((item) => {
        if (!item) return false;
        return (
          (item.categoryName && item.categoryName.includes(searchKeyword)) ||
          (item.status && item.status.includes(searchKeyword)) ||
          (item.subject && item.subject.includes(searchKeyword)) ||
          (item.message && item.message.includes(searchKeyword))
        );
      }) || []
    );
  }

  const [assignBulkTicket] = useAssignBulkTicketMutation();
  const formik = useFormik({
    initialValues: {
      priority: '',
      dueDate: '',
      userToAssign: ''
    },
    validationSchema: builkAssignTicket,
    onSubmit: async (values) => {
      try {
        setLoadingBulkAssign(true);
        const model = {
          tickets: checkedTickets?.map(item => item.id),
          priority: values?.priority,
          dueDate: values?.dueDate,
          userToAssign: values?.userToAssign
        }
        const response = await assignBulkTicket(model).unwrap();
        if (response) {
          showToastSuccess(response?.ResponseMessage);
          handleHideModal();
          setCheckedTickets([]);
          getAllTicketRefresh();
        }
      }
      catch (error: any) {
        showToastError(error?.data.ResponseMessage)
      }
      finally {
        setLoadingBulkAssign(false);
      }
    },
  });

  // Function to handle page change
  const onPageChange = (page: number) => {
    setQuery({ ...query, Page: page })
    // You can perform actions like fetching data for the new page here
  };

  useEffect(() => {
    if (activeTab == 'Live Chat') {
      setActiveFilter('');
    }
    if (activeTab == 'All') {
      getAllTicketRefresh();
    }
  }, [activeTab])

  const handleCheckboxChange = (item: TicketDto) => {
    const isChecked = checkedTickets.some((checkedItem) => checkedItem === item);

    if (isChecked) {
      // If already checked, remove it from the array
      const newCheckedTickets = checkedTickets.filter((checkedItem) => checkedItem !== item);
      setCheckedTickets(newCheckedTickets);
    } else {
      // If not checked, add it to the array
      setCheckedTickets([...checkedTickets, item]);
    }
  };

  const handleCheckAllChange = () => {
    setCheckedAll(!checkedAll);
  };

  const handleApplyFIlter = () => {
    setQuery({ ...query, CategoryId: sideDrawerFilter.categoryName, TicketStatus: sideDrawerFilter.status, OrderBy: sideDrawerFilter.sortBy, Priority: sideDrawerFilter.priority })
    getAllTicketRefresh();
    setShowOffCanvas(false);
  }

  const handleApplySearch = () => {
    setQuery({ ...query, SearchKeyword: sideDrawerFilter.searchKeyword })
    getAllTicketRefresh();
  }

  const handleClearFilter = () => {
    setSideDrawerFilter({ ...sideDrawerFilter, searchKeyword: '', sortBy: '', categoryName: '', status: '', priority: '' })
    setQuery({ ...query, CategoryId: undefined, TicketStatus: undefined, OrderBy: undefined, SearchKeyword: undefined, Priority: undefined })
    getAllTicketRefresh();
  }

  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);

  return (
    <Layout>
      <section className='my-2'>

        <div className='row sticky-top bg-light pt-3 pb-2 mb-2' style={{ top: '0', zIndex: 10, margin: '0 -50px', padding: '0 50px' }}>
          <div className='col-lg-6'>
            <h5 className='fw-bold'>Request</h5>
            <div className='text-secondary font-size-normal'><span>Request</span> <GoChevronRight className='my-2' />  <span>{activeFilter}</span></div>
          </div>
          {activeFilter === 'Ticket Details' && <div className='col-lg-6 text-end'><button hidden={activeTab !== 'Live Chat'} type='button' className='btn-yellow rounded-4 text-center w-auto me-3 px-3'><GoCheckCircle size={18} className='me-2' />fcvg Create a ticket</button>
            <button hidden={hasPermissions['Manage Requests'] ? false : true} type='button' onClick={() => { setModalTab('Confirm'); setShowModal(true) }} className='btn btn-success rounded-4 text-center font-size-smm py-2 w-auto'><GoCheckCircle size={18} className='me-2' /> Mark ticket as resolved</button> </div>}
          {(activeFilter !== "Assigned Tickets" && activeFilter !== "Tickets Details") && <div className='col-lg-6 text-end'>
            {checkedTickets?.length > 0 && <div className='d-inline me-2'>
              <button hidden={hasPermissions['Manage Requests'] ? false : true} type='button' onClick={() => { setModalTab("Assign BulkTicket"); setShowModal(true) }} className='btn btn-success me-3'><GoPlus size={20} /> Assign Ticket(s)</button>
            </div>}
            {activeTab !== 'Live Chat' && !ticketDetails && <> <Form.Control type='text' value={sideDrawerFilter.searchKeyword} onChange={(e) => setSideDrawerFilter({ ...sideDrawerFilter, searchKeyword: e.target.value })} placeholder='Search' className='d-inline rounded-5 search-input light-text w-auto me-2 py-2' />
              <button onClick={() => handleApplySearch()} className='btn-secondary-outline me-2 px-3'><FaSearch size={20} /></button>
              <button onClick={() => setShowOffCanvas(true)} className='btn-secondary-outline px-3'> <GoFilter size={20} className='me-2' /> Filter</button>
              <button hidden={!query.SearchKeyword && !query.OrderBy && !query.Priority && !query.TicketStatus && !query.CategoryId} onClick={() => handleClearFilter()} className='btn-secondary-outline px-3 ms-2'> Clear Filter</button></>}
          </div>}
          <OffCanvasModal showOffCanvas={showOffCanvas} hideOffCanvas={handleHideOffCanvas}>
            <div className='px-4'>
              <h3 className='fw-bold mt-n4 mb-4'>Filter</h3>
              <div>
                <p className="dark-text">STATUS</p>
                <p><Form.Check type='checkbox' checked={sideDrawerFilter?.status === 'Pending'} label='Pending' name='Oldest' onChange={() => setSideDrawerFilter({ ...sideDrawerFilter, status: 'Pending' })} className="dark-text" /></p>
                <p><Form.Check type='checkbox' checked={sideDrawerFilter?.status === 'Assigned'} label='Assigned' name='Oldest' onChange={() => setSideDrawerFilter({ ...sideDrawerFilter, status: 'Assigned' })} className="dark-text" /></p>
                <p><Form.Check type='checkbox' checked={sideDrawerFilter?.status === 'Resolved'} label='Resolved' name='Resolved' onChange={() => setSideDrawerFilter({ ...sideDrawerFilter, status: 'Resolved' })} className="dark-text" /></p>
                <p><Form.Check type='checkbox' checked={sideDrawerFilter?.status === 'Overdue'} label='Overdue' name='Overdue' onChange={() => setSideDrawerFilter({ ...sideDrawerFilter, status: 'Overdue' })} className="dark-text" /></p>
              </div>
              <hr className='my-5' />
              <div className='mb-5'>
                <p className="dark-text">CATEGORY</p>
                {allcategories && allcategories?.map((item, key) => <p key={key}><Form.Check type='checkbox' checked={sideDrawerFilter?.categoryName === item?.id} label={item?.categoryName} name='category' id='category' onChange={() => setSideDrawerFilter({ ...sideDrawerFilter, categoryName: item?.id })} className="dark-text" /></p>)}
              </div>
              <hr className='my-5' />
              <div className='mb-5'>
                <p className="dark-text">PRIORITY</p>
                {Object.values(Priority).map((priority) => <p><Form.Check type='checkbox' checked={sideDrawerFilter?.priority === priority} label={priority} name='category' id='category' onChange={() => setSideDrawerFilter({ ...sideDrawerFilter, priority: priority })} className="dark-text" /></p>)}
              </div>
              <hr className='my-5' />
              <div className='mb-5'>
                <p className="dark-text">SORT BY</p>
                <p><Form.Check label='Newest First' checked={sideDrawerFilter?.sortBy == 'RecentlyAdded'} onChange={() => setSideDrawerFilter({ ...sideDrawerFilter, sortBy: 'RecentlyAdded' })} name='role' id='role' className="dark-text" /></p>
                <p><Form.Check label='Oldest First' checked={sideDrawerFilter?.sortBy == 'Oldest'} onChange={() => setSideDrawerFilter({ ...sideDrawerFilter, sortBy: 'Oldest' })} name='role' id='role' className="dark-text" /></p>
              </div>
              <div className='pt-5'><button type='button' onClick={() => handleApplyFIlter()} className='btn-primary w-100 py-2'>Apply filter</button></div>
            </div>
          </OffCanvasModal>
        </div>
        {activeTab === 'All' &&
          <div className='row text-secondary'>
            <div className='col-lg-2 sticky-top' style={{ top: '80px', height: 'fit-content', zIndex: 5 }}>
              <button type='button' onClick={() => { handleStatusTicket('All'); setActiveFilter("All") }} className={`${activeFilter === "All" || activeFilter === "Ticket Details" ? 'btn-primary-outline' : 'btn-secondary-outline'} d-flex gap-4 font-size-sm first-font-medium px-3 mb-3 w-100`}> <FiFolderPlus size={20} /> All</button>
              <button type='button' onClick={() => handleStatusTicket('UNASSIGNED')} className={`${activeFilter === "UNASSIGNED" ? 'btn-primary-outline' : 'btn-secondary-outline'} d-flex gap-4 font-size-sm first-font-medium px-3 my-3 w-100`}> <FiFolderMinus size={20} /> Unassigned</button>
              <button type='button' onClick={() => handleStatusTicket('PENDING')} className={`${activeFilter === "PENDING" ? 'btn-primary-outline' : 'btn-secondary-outline'} d-flex gap-4 font-size-sm first-font-medium px-3 my-3 w-100`}> <PiFolderOpen size={20} />Pending</button>
              <button type='button' onClick={() => handleStatusTicket('OVERDUE')} className={`${activeFilter === "OVERDUE" ? 'btn-primary-outline' : 'btn-secondary-outline'} d-flex gap-4 font-size-sm first-font-medium px-3 my-3 w-100`}> <FiArrowUpRight size={20} /> Overdue</button>
              <button type='button' onClick={() => handleStatusTicket('RESOLVED')} className={`${activeFilter === "RESOLVED" ? 'btn-primary-outline' : 'btn-secondary-outline'} d-flex gap-4 font-size-sm first-font-medium px-3 my-3 w-100`}> <GoCheckCircle size={20} /> Resolved</button>
              <button hidden={hasPermissions['Manage Requests'] ? false : true} type='button' onClick={() => setActiveFilter("Assigned Tickets")} className={`${activeFilter === "Assigned Tickets" ? 'btn-primary-outline' : 'btn-secondary-outline'} d-flex gap-4 font-size-sm first-font-medium px-3 my-3 w-100`}>Assigned Tickets</button>
              <button hidden={hasPermissions['Manage Requests'] ? false : true} type='button' onClick={() => setActiveFilter("New Ticket")} className={`${activeFilter === "New Ticket" ? 'btn-primary-outline' : 'btn-secondary-outline'} d-flex gap-4 font-size-sm first-font-medium px-3 my-3 w-100`}><GoPlus size={20} /> New Ticket</button>
              {/* <div className='mt-5'>
              <button hidden={hasPermissions['Manage Requests'] ? false : true} type='button' onClick={() => { setModalTab('addCategories'); setShowModal(true) }} className='btn btn-success rounded-3 text-center font-size-sm first-font-medium py-2 px-1 my-3 w-100'> Create Category</button>
            </div> */}
            </div>

            <div className='col-lg-10 px-5' >
              {loading ? <div className='text-center p-5'><Spinner /> <p>Loading... </p></div> :
                <div className='request-table'>

                  {['All', 'PENDING', 'ASSIGNED', 'RESOLVED', 'UNASSIGNED', 'OVERDUE', 'New'].includes(activeFilter) ?
                    <><Table className='table sticky-thead'>
                      <thead>
                        <tr>
                          <th>
                            {hasPermissions['Manage Requests'] && <Form.Check type='checkbox' onChange={handleCheckAllChange} className='d-inline' checked={checkedAll} />}
                          </th>
                          <th>
                            <label className='table-filter fw-normal font-size-sm border-0 w-auto py-0'>Company <GoTriangleDown className='text-secondary' /></label>
                          </th>
                          <th>
                            <label className='table-filter fw-normal font-size-sm border-0 w-auto py-0'>Priority <GoTriangleDown className='text-secondary' /></label>
                          </th>
                          <th>
                            <label className='table-filter fw-normal font-size-sm border-0 w-auto py-0'>Category <GoTriangleDown className='text-secondary' /></label>
                          </th>
                          <th className=''>
                            <label className='table-filter fw-normal font-size-sm border-0 w-auto py-0'>Request <GoTriangleDown className='text-secondary' /></label>
                          </th>
                          <th className=''>
                            <label className='table-filter fw-normal font-size-sm border-0 w-auto py-0'>Status <GoTriangleDown className='text-secondary' /></label>
                          </th>
                          <th className='text-center'>
                            <label className='table-filter fw-normal font-size-sm border-0 w-auto py-0'>Date <GoTriangleDown className='text-secondary' /></label>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {ticketsFilter ? ticketsFilter?.map((item, key) => <tr key={key} className='align-middle'>
                          <td>
                            {hasPermissions['Manage Requests'] && <Form.Check type='checkbox' onChange={() => handleCheckboxChange(item)} className='d-inline' />} &nbsp;
                            {item?.isChatExist && <span><IoChatboxEllipses className='text-primary' size={20} /></span>} &nbsp;
                            {item?.ticketReplies?.filter(item => item?.isRead == false)?.length > 0 && <span className='badge bg-danger rounded-circle text-white'>{item?.ticketReplies?.filter(item => item?.isRead == false)?.length}</span>}
                            &nbsp; <GoStar className='d-inline' />
                          </td>
                          <td className='lh-base' style={{ cursor: 'pointer' }} onClick={() => { setTicketDetails(item); setActiveFilter('Ticket Details') }}><span className={`fw-bold font-size-sm ${item?.isRead ? 'text-secondary' : ''}`}>{item?.customerName}</span><br /><span className={`font-size-smm ${item?.isRead ? 'text-secondary' : ''}`}>{item?.customerEmail}</span></td>
                          <td>
                            <span className="font-size-sm" style={{
                              color: item?.priority?.toUpperCase() === 'MEDIUM' ? '#219653' :
                                item?.priority?.toUpperCase() === 'URGENT' || item?.priority?.toUpperCase() === 'HIGH' ? '#008CFE' :
                                  item?.priority?.toUpperCase() === 'VIP' ? '#EB5757' :
                                    item?.priority?.toUpperCase() === 'LOW' ? '#807E7C' : 'inherit'
                            }}>
                              {item?.priority?.toUpperCase() === 'MEDIUM' ? 'Medium' :
                                item?.priority?.toUpperCase() === 'URGENT' || item?.priority?.toUpperCase() === 'HIGH' ? 'Urgent' :
                                  item?.priority?.toUpperCase() === 'VIP' ? 'VIP' :
                                    item?.priority?.toUpperCase() === 'LOW' ? 'Low' : 'None'}
                            </span>
                          </td>
                          <td><div className='my-auto'><span className={`font-size-sm ${item?.isRead ? 'text-secondary' : ''}`}>{item?.categoryName}</span></div></td>
                          <td className='lh-base truncate-cell' onClick={() => { setTicketDetails(item); setActiveFilter('Ticket Details') }}><span className={`fw-bold font-size-sm ${item?.isRead ? 'text-secondary' : ''}`}>{item?.subject}</span>
                          </td>
                          <td><button type='button' className={`btn font-size-sm ${item?.status === 'PENDING' ? 'status-pending' : item?.status === 'ASSIGNED' ? 'btn-success' : item?.status === 'RESOLVED' ? 'status-resolved' : 'btn-danger'} btn-sm font-size-smm rounded-3 py-1`}>{item?.status}</button></td>
                          <td className='text-center'><span className={`font-size-sm ${item?.isRead ? 'text-secondary' : ''}`}>{dayjs(item?.createdAt).format('MMM DD, YYYY')}</span></td>
                        </tr>)
                          : <tr><td colSpan={7} className='p-4'> No data available</td></tr>}
                      </tbody>
                    </Table>


                    </>
                    : activeFilter === 'Ticket Details' ? <TicketDetails ticketId={ticketDetails?.id} handleReturn={handleReturn} />
                      : activeFilter === 'Assigned Tickets' ? <ReportStatistics />
                        : activeFilter === 'New Ticket' ? <NewTicket handleReturn={handleReturn} />
                          : ""}
                </div>
              }
            </div>
    
        {/* Pagination Numbers starts here */}
        {(['All', 'PENDING', 'ASSIGNED', 'RESOLVED', 'UNASSIGNED', 'OVERDUE', 'New'].includes(activeFilter) && !loading) && (
          <div className='text-end py-3' style={{ marginTop: '-63px' }}>
            <Pagination
              current={tickets?.pageNumber || 0}
              total={tickets?.totalSize}
              pageSize={tickets?.pageSize}
              onChange={onPageChange}
            />
          </div>
        )}
        {/* Pagination Numbers ends here */}
      </div>}

        {activeTab === 'Subscription' && <RequestSubscription />}
        {/* {activeTab === 'Live Chat' && <LiveChatHistory />} */}

        <ModalComponent size={undefined} showModal={showModal} hideModal={() => handleHideModal()}>
          <div className='p-4'>
            {modalTab === 'Confirm' && <div className='px-3'>
              <div className='my-3 text-center'><img src={info} width='120px' /></div>
              <p className='fs-5 fw-bold'>Are you sure you want to mark as resolved?</p>
              <p className='text-secondary'>Marking as resolved would remove this message from your ticket list. Be sure this issue has been resolved before marking as resolved</p>
              <div className='pt-3 pb-4'>
                <button disabled={loading} type='button' onClick={() => handleUpdateTicketStatus()} className='btn-primary w-100 border-0 py-3 rounded-5'>Proceed {loadingStatus && <Spinner size='sm' />}</button>
              </div>
            </div>}
            {modalTab === 'Assign BulkTicket' && <div className='px-3'>
              <Form onSubmit={formik.handleSubmit}>
                <div className='my-3 text-center'><img src={assignBulk} width='120px' /></div>
                <p className='fs-5 fw-bold'>Assign selected tickets to</p>
                {/* <p className='text-secondary'>Select a category type you would like to assign the selected ticket(s) to </p>
                <div className='d-flex gap-3 font-size-sm text-secondary'>
                  <Form.Check type='radio' name='details' className='d-inline-block' label="Individual" />
                  <Form.Check type='radio' disabled name='details' className='d-inline-block' label="Admin Category (Coming Soon)" />
                  <Form.Check type='radio' name='details' className='d-inline-block' label="Enterprise" /> 
                <Form.Check type='radio' name='details' className='d-inline-block' label="General Inq" />
                </div> */}
                <FloatingLabel controlId="floatingInput" label="Assign Ticket To" className="float-input mt-4 px-0" >
                  <Form.Select aria-label="Floating label select example" name="userToAssign" value={formik?.values?.userToAssign} onChange={formik?.handleChange} onBlur={formik?.handleBlur} className="">
                    <option value=''>Assign to</option>
                    {adminUsers?.items?.map((users, key) => <option key={key} value={users?.userId}>{users?.firstName} {users?.lastName}</option>)}
                  </Form.Select>
                  {formik.touched.userToAssign && formik.errors.userToAssign && <span className='text-danger font-size-sm'>{formik.errors.userToAssign}</span>}
                </FloatingLabel>
                <FloatingLabel controlId="floatingInput" label="Select Priority" className="float-input mt-4 px-0" >
                  <Form.Select aria-label="Floating label select example" name="priority" value={formik?.values?.priority} onChange={formik?.handleChange} onBlur={formik?.handleBlur} className="">
                    <option value=''>Priority</option>
                    {Object.values(Priority).map((priority, key) => (
                      <option key={key} value={priority}>
                        {priority}
                      </option>
                    ))}
                  </Form.Select>
                  {formik.touched.priority && formik.errors.priority && <span className='text-danger font-size-sm'>{formik.errors.priority}</span>}
                </FloatingLabel>
                <FloatingLabel controlId="floatingInput" label="Due Date" className="float-input mt-4 px-0" >
                  <Form.Control type="date" min={tomorrow.toISOString().split('T')[0]} name="dueDate" value={formik?.values?.dueDate} onChange={formik?.handleChange} onBlur={formik?.handleBlur} placeholder="Select Date" />{formik.touched.dueDate && formik.errors.dueDate && <span className='text-danger font-size-sm'>{formik.errors.dueDate}</span>}
                </FloatingLabel>
                <div className='pt-3 pb-4'>
                  <button disabled={loadingBulkAssign} type='submit' className='btn-primary w-100 border-0 py-3 rounded-5'>Save {loadingBulkAssign && <Spinner size='sm' />}</button>
                </div>
              </Form>
            </div>}
            {modalTab === 'addCategories' && <div className='px-3 py-4'>
              <p className='fs-5 fw-bold pb-4'>Add New Categories</p>
              <Form.Control onChange={(e) => setNewCategory(e.target.value)} aria-label="Floating label select example" placeholder='Enter category name' className="input-field w-100 my-3" />
              <div className='pt-3 pb-4'>
                <button disabled={loadingCategory} type='button' onClick={() => handleAddCategory()} className='btn-primary w-100 border-0 py-3 rounded-5'>Save {loadingCategory && <Spinner size='sm' />}</button>
              </div>
            </div>}
          </div>
        </ModalComponent>
      </section>
    </Layout >
  )
}

export default Request;
